<template>
    <!-- Facturador - Anticipos -->
    <div class="contenedor_modal_completo">
        <div class="contenedor_modal_completo_cabecera">
            <button type="button" class="btn btn-sm btn-outline-dark" v-shortkey="['esc']" @shortkey="cerrar"
                @click="cerrar">Cerrar</button>
        </div>
        <div class="contenedor_modal_completo_contenido">
            <b-container>
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h2>
                            Registro de anticipos xx
                        </h2>
                    </div>

                    <div class="col-sm-9 mt-3">
                        <label for="" class="form-label">Código</label>
                        <input type="text" id="campo_id_anticipo_codigo" autocomplete="off"
                            class="form-control form-control-sm" v-model="codigo" @keydown.enter="obtener_registros">
                    </div>
                    <div class="col-sm-3 mt-5">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="obtener_registros"><i class="fas fa-search"></i>
                            Buscar</button>

                        <button v-if="!botonFacturarHabilitado" type="button" style="width: 254px;"
                            class="btn btn-sm btn-outline-success btn-block btn-registrar" @click="abrir_modal_registro"
                            :disabled="!botonRegistrarHabilitado"><i class="fas fa-plus"></i>
                            Registrar</button>

                        <button v-else type="button" style="width: 254px;"
                            class="btn btn-sm btn-outline-success btn-block btn-registrar" disabled><i
                                class="fas fa-plus"></i>
                            Registrar</button>

                        <button type="button" style="width: 254px;"
                            class="btn btn-sm btn-outline-dark btn-block btn-facturar" @click="abrir_modal_facturar"
                            :disabled="!botonFacturarHabilitado"><i class="fas fa-dollar-sign"></i>
                            Facturar</button>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <table style="width: 100%;">
                            <tr>
                                <td style="width: 15%;">
                                    Nombre cliente:
                                </td>
                                <td style="width: 85%;">
                                    {{ datos_cl.nombre_cliente }}
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 15%;">
                                    NIT:
                                </td>
                                <td style="width: 85%;">
                                    {{ datos_cl.nit }}
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 15%;">
                                    Fecha creación:
                                </td>
                                <td style="width: 85%;">
                                    {{ fecha_creacion }}
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 15%;">
                                    Código anticipo:
                                </td>
                                <td style="width: 85%;">
                                    {{ codigo_anticipo }}
                                </td>
                            </tr>
                        </table>
                    </div>


                    <div class="col-sm-6 mt-3">
                        <b-card-group deck>
                            <b-card bg-variant="warning" text-variant="black" style="font-size: 30px;"
                                header="Monto total" class="text-center">
                                <b-card-text class="estilos_cards">
                                    Q{{ capital.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    }) }}
                                </b-card-text>
                            </b-card>
                        </b-card-group>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <b-card-group deck>
                            <b-card bg-variant="dark" text-variant="white" style="font-size: 30px;"
                                header="Saldo pendiente" class="text-center">
                                <b-card-text class="estilos_cards">
                                    Q{{ saldo_pendiente.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    }) }}
                                </b-card-text>
                            </b-card>
                        </b-card-group>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <div class="marco_registros_anticipos">
                            <table class="table table-sm table-striped table-bordered" style="font-size: 13px;">
                                <thead>
                                    <tr>
                                        <th style="width: 15%">Fecha</th>
                                        <th style="width: 70%">Ref.</th>
                                        <th style="width: 15%;text-align: center;">Anticipo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in registros" :key="index">
                                        <td>
                                            {{ item.fecha }}
                                        </td>
                                        <td>
                                            {{ item.documentId }}
                                        </td>
                                        <td style="text-align:center;">
                                            Q{{ item.monto.toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>

                </b-row>
            </b-container>
        </div>

        <!-- Modal para registro de anticipos -->
        <ModalRegistroAnticipo v-if="modal_registro" v-on:salir="cerrar_modal_registro"
            v-on:actualizar="obtener_registros" v-on:actualizar_registros="obtener_registros" />

        <!-- Modal para generar venta -->
        <GenerarVenta v-if="modal_facturar" v-on:salir="cerrar_modal_facturar"
            v-on:anticipo_completo="obtener_registros" />
    </div>
</template>

<script>
    import { minix } from '@/components/functions/alertas'
    import { mapActions, mapMutations, mapState } from 'vuex'
    import ModalRegistroAnticipo from './ModalRegistroAnticipo.vue'
    import GenerarVenta from './GenerarVenta.vue'

    export default {
        name: 'Anticipos',
        components: {
            ModalRegistroAnticipo,
            GenerarVenta
        },
        computed: {
            ...mapState(['datos_usuario']),
            botonRegistrarHabilitado() {
                return Object.keys(this.datos_cl).length > 0 && this.registros.length > 0 && this.saldo_pendiente > 0
            },
            botonFacturarHabilitado() {
                return Object.keys(this.datos_cl).length > 0 && this.registros.length > 0 && this.saldo_pendiente == 0 && this.anticipo_completo_ == false
            }
        },
        data() {
            return {
                codigo: '',
                datos_cl: {},
                capital: 0,
                saldo_pendiente: 0,
                registros: [],
                fecha_creacion: '',
                codigo_anticipo: '',
                modal_registro: false,
                modal_facturar: false,
                anticipo_completo_: false
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            abrir_modal_registro() {
                this.set_datos_anticipo_modal({
                    correlativo_anticipo: this.codigo_anticipo,
                    total: this.capital,
                    saldo_pendiente: this.saldo_pendiente
                })
                this.modal_registro = true
            },
            cerrar_modal_registro() {
                this.modal_registro = false
            },
            abrir_modal_facturar() {
                this.modal_facturar = true
            },
            cerrar_modal_facturar() {
                this.modal_facturar = false
            },
            async obtener_registros() {
                if (this.codigo.trim() == '') {
                    minix({ icon: 'info', mensaje: 'Escribe un código de anticipo', tiempo: 3000 })
                    document.getElementById('campo_id_anticipo_codigo').focus()
                    return
                }

                let consulta_capital = {
                    api: `anticipos?filters[correlativo_anticipo][$eq][0]=${this.codigo.trim()}&filters[capital][$eq][1]=${true}&filters[anulado][$eq][2]=false`
                }

                let consulta_anticipos = {
                    api: `anticipos?filters[correlativo_anticipo][$eq][0]=${this.codigo.trim()}&filters[capital][$eq][1]=${false}&filters[anulado][$eq][2]=false`
                }

                let cc = await this.obtener_data(consulta_capital)
                let ca = await this.obtener_data(consulta_anticipos)

                if (cc.length == 0 || ca.length == 0) {
                    minix({ icon: 'info', mensaje: 'No se encontraron registros', tiempo: 3000 })
                    document.getElementById('campo_id_anticipo_codigo').focus()
                    return
                }

                // Guardar cc y ca en el state
                this.set_datos_anticipo_completo({
                    capital: cc,
                    anticipos: ca
                })

                this.datos_cl = cc[0].datos_cliente
                this.capital = cc[0].monto
                this.fecha_creacion = cc[0].fecha
                this.codigo_anticipo = cc[0].correlativo_anticipo
                this.anticipo_completo_ = cc[0].completo

                this.registros = ca


                let contador = 0
                for (let i = 0; i < ca.length; i++) {
                    const e = ca[i];

                    contador += e.monto
                }

                this.saldo_pendiente = cc[0].monto - contador

            },
            ...mapActions(['guardar_data', 'obtener_data']),
            ...mapMutations(['set_datos_anticipo_modal', 'set_datos_anticipo_completo'])
        },
    }
</script>

<style>
    .estilos_cards {
        font-size: 50px;
        font-weight: bold;
    }

    .marco_registros_anticipos {
        width: 100%;
        height: calc(100vh - 535px);
        overflow: auto;
    }

    .btn-registrar {
        position: absolute;
        top: 45px;
        width: calc(100% - 30px);
        margin-top: 10px;
        z-index: 999;
    }

    .btn-facturar {

        position: absolute;
        top: 95px;
        width: calc(100% - 30px);
        margin-top: 10px;
        z-index: 999;
    }
</style>